import * as angular from 'angular';
import { guidEmpty } from '../../common';
import { ComponentDefinition } from '../../models';

export class VariablesAndUnitSelector implements angular.IComponentController {
    isDisabled: boolean;
    isRequired: boolean;
    model: any;

    static $inject = [];

    $onInit() {
        if (!this.model) {
            this.model = {
                VariableTypeGuid: guidEmpty,
                VariableSubTypeGuid: guidEmpty,
                QualifierGuid: guidEmpty,
                UnitGuid: guidEmpty
            };
        }
    }
}

export const wtVariablesAndUnitSelector: ComponentDefinition = {
    componentId: 'wtVariablesAndUnitSelector',
    controller: VariablesAndUnitSelector,
    template: require('./variablesAndUnitSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        isDisabled: '<?',
        isRequired: '=?',
        model: '=',
        name: '@?'
    }
};